import { Controller } from "@hotwired/stimulus"

// Handles per-scene settings interactions: Veo audio toggle, playback rate
// (applied live to video preview), overhang effect controls, Ken Burns hint.
export default class extends Controller {
  static targets = [
    "volumeControl", "volumeDisplay",
    "playbackRateDisplay",
    "overhangControls", "focalXDisplay", "focalYDisplay", "zoomSpeedDisplay",
    "videoPlayer", "videoWrapper", "previewNote"
  ]

  connect() {
    if (this.hasVideoPlayerTarget) {
      const rate = parseFloat(this.videoPlayerTarget.dataset.playbackRate || 1)
      if (rate !== 1) this.videoPlayerTarget.playbackRate = rate
    }
  }

  toggleVeoAudio(event) {
    if (this.hasVolumeControlTarget) {
      this.volumeControlTarget.classList.toggle("hidden", !event.target.checked)
    }
  }

  updateVeoVolumeDisplay(event) {
    if (this.hasVolumeDisplayTarget) {
      this.volumeDisplayTarget.textContent = `${Math.round(event.target.value * 100)}%`
    }
  }

  updatePlaybackRateDisplay(event) {
    const rate = parseFloat(event.target.value)
    if (this.hasPlaybackRateDisplayTarget) {
      this.playbackRateDisplayTarget.textContent = `${Math.round(rate * 100)}%`
    }
    if (this.hasVideoPlayerTarget) {
      this.videoPlayerTarget.playbackRate = rate
    }
    if (this.hasPreviewNoteTarget) {
      this.previewNoteTarget.textContent = rate < 1
        ? `Preview plays at ${Math.round(rate * 100)}% speed (approximation)`
        : ""
    }
  }

  toggleOverhangControls(event) {
    if (this.hasOverhangControlsTarget) {
      this.overhangControlsTarget.classList.toggle("hidden", event.target.value === "none")
    }
  }

  updateFocalDisplay(event) {
    const name = event.target.name
    const pct = `${Math.round(event.target.value * 100)}%`
    if (name === "overhang_focal_x" && this.hasFocalXDisplayTarget) {
      this.focalXDisplayTarget.textContent = pct
    } else if (name === "overhang_focal_y" && this.hasFocalYDisplayTarget) {
      this.focalYDisplayTarget.textContent = pct
    }
  }

  updateZoomSpeedDisplay(event) {
    if (this.hasZoomSpeedDisplayTarget) {
      this.zoomSpeedDisplayTarget.textContent = `${parseFloat(event.target.value).toFixed(1)}x`
    }
  }
}
